import React from 'react'
import { Button, Spinner, Typography } from '@telavita-core/react-design-kit'

import { RelationshipEnum } from 'models/Enums'
import { FamilyContact, ModifiedAddress } from 'models/Auth'

import * as S from './styles'

type InfoProps = {
  label: string
  value: string
}

interface ConfirmAddressAndFamilyContactDataProps {
  handleEditInfo: () => void
  handleCompleteForm: () => void
  formValues: {
    address: ModifiedAddress
    familyContact: FamilyContact
  }
  isLoading: boolean
}

const Info = ({ label, value }: InfoProps) => {
  return (
    <S.InfoTitleWrapper>
      <Typography variant='content2'>
        {label}
      </Typography>
      <Typography variant='content2'>
        {value}
      </Typography>
    </S.InfoTitleWrapper>
  )
}

const Loading = () => {
  return (
    <S.SpinnerWrapper>
      <Spinner />
    </S.SpinnerWrapper>
  )
}

export const ConfirmAddressAndFamilyContactData = ({
  handleEditInfo, 
  handleCompleteForm,
  formValues,
  isLoading
}: ConfirmAddressAndFamilyContactDataProps): JSX.Element => {
  const { address, familyContact } = formValues

  const addressInfo: InfoProps[] = [
    { label: 'CEP', value: address['cep'] },
    { label: 'Endereço', value: address['address'] },
    { label: 'Número', value: address['number'] },
    { label: 'Complemento', value: address['complement'] },
    { label: 'Bairro', value: address['neighborhood'] },
    { label: 'Cidade', value: address['city'] },
    { label: 'Estado', value: address['state'] }
  ]

  const familyContactInfo: InfoProps[] = [
    { label: 'Nome', value: familyContact['fullName'] },
    { label: 'Parentesco', value: RelationshipEnum[familyContact['relationship'] as keyof typeof RelationshipEnum]},
    { label: 'Telefone', value: familyContact['phone'] }
  ]

  return (
    <S.Container>
      <S.InfoBlockWrapper>
        <Typography variant='content2' weight='bold'>
          Seu endereço
        </Typography>

        {addressInfo.map((info) => (
          <Info key={info.label} label={info.label} value={info.value} />
        ))}
      </S.InfoBlockWrapper>

      <S.InfoBlockWrapper>
        <Typography variant='content2' weight='bold'>
          Contato de uma familiar
        </Typography>

        {familyContactInfo.map((info) => (
          <Info key={info.label} label={info.label} value={info.value} />
        ))}
      </S.InfoBlockWrapper>

      <S.ButtonContainer>
        <Button 
          variant='outlined' 
          uppercase={false}
          onClick={handleEditInfo}
        >
          Editar informações
        </Button>
        <Button 
          variant='contained' 
          uppercase={false}
          onClick={isLoading 
            ? () => null 
            : () => handleCompleteForm()
          }
        >
          {isLoading ? <Loading /> : 'Confirmar e enviar'}
        </Button>
      </S.ButtonContainer>
    </S.Container>
  )
}